import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { UserPlus, User } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const AssignModal = ({ isOpen, onClose, instrument, onAssign }) => {
  const [selectedResponsible, setSelectedResponsible] = useState(instrument.responsavel);
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedResponsible) {
      toast({
        title: 'Selecione um responsável',
        description: 'Por favor, escolha um responsável antes de continuar.',
        variant: 'destructive',
      });
      return;
    }
    onAssign(instrument.id, selectedResponsible);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-2xl">
            <UserPlus className="w-6 h-6 text-green-600" />
            Atribuir Responsável
          </DialogTitle>
          <DialogDescription>
            Selecione o responsável pelo instrumento
          </DialogDescription>
        </DialogHeader>

        {/* Instrument Info */}
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-4 border border-green-200">
          <h3 className="font-bold text-slate-900 mb-1">{instrument.nome}</h3>
          <p className="text-sm text-slate-700">
            {instrument.marca} - {instrument.tipo}
          </p>
          <div className="flex items-center gap-2 mt-2">
            <User className="w-4 h-4 text-green-600" />
            <span className="text-sm text-slate-700">
              <strong>Responsável atual:</strong> {instrument.responsavel || 'Nenhum'}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="responsible" className="text-base">
              Novo Responsável
            </Label>
            <Input
              id="responsible"
              value={selectedResponsible}
              onChange={(e) => setSelectedResponsible(e.target.value)}
              placeholder="Digite o nome do responsável"
              className="mt-2"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} className="flex-1">
              Cancelar
            </Button>
            <Button type="submit" className="flex-1 bg-green-600 hover:bg-green-700">
              Atribuir
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AssignModal;